const broadcastChannel = new BroadcastChannel('nexway-tpdigital')

export const addBroadcastEventListener = (
  eventName: string,
  handler: (payload?: unknown) => void,
) => {
  broadcastChannel.addEventListener(
    'message',
    (event: MessageEvent<{ name: string; payload?: unknown }>) => {
      const { name, payload } = event.data

      if (name !== eventName) return

      handler(payload)
    },
  )
}

export const sendBroadcastEvent = (eventName: string, payload?: unknown) =>
  broadcastChannel.postMessage({ name: eventName, payload })
